/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateSupplierFunctionRequest,
  GetSupplierFunctionParams,
  ListSupplierFunctionsParams,
  PaginatedSupplierFunctionDto,
  SupplierFunctionDto,
  SupplierFunctionId,
  UpdateSupplierFunctionRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getListSupplierFunctionsUrl = (params: ListSupplierFunctionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/supplier-functions?${stringifiedParams}`
    : `/api/v1/engineering/supplier-functions`;
};

/**
 * @summary List supplier functions
 */
export const listSupplierFunctions = async (
  params: ListSupplierFunctionsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedSupplierFunctionDto> => {
  return customFetch<PaginatedSupplierFunctionDto>(getListSupplierFunctionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateSupplierFunctionUrl = () => {
  return `/api/v1/engineering/supplier-functions`;
};

/**
 * @summary Create supplier function
 */
export const createSupplierFunction = async (
  createSupplierFunctionRequest: CreateSupplierFunctionRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierFunctionId> => {
  return customFetch<SupplierFunctionId>(getCreateSupplierFunctionUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createSupplierFunctionRequest),
  });
};

export const getGetSupplierFunctionUrl = (
  id: SupplierFunctionId,
  params?: GetSupplierFunctionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/supplier-functions/${id}?${stringifiedParams}`
    : `/api/v1/engineering/supplier-functions/${id}`;
};

/**
 * @summary Get supplier function
 */
export const getSupplierFunction = async (
  id: SupplierFunctionId,
  params?: GetSupplierFunctionParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierFunctionDto> => {
  return customFetch<SupplierFunctionDto>(getGetSupplierFunctionUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateSupplierFunctionUrl = (id: SupplierFunctionId) => {
  return `/api/v1/engineering/supplier-functions/${id}`;
};

/**
 * @summary Update supplier function
 */
export const updateSupplierFunction = async (
  id: SupplierFunctionId,
  updateSupplierFunctionRequest: UpdateSupplierFunctionRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateSupplierFunctionUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateSupplierFunctionRequest),
  });
};

export const getDeleteSupplierFunctionUrl = (id: SupplierFunctionId) => {
  return `/api/v1/engineering/supplier-functions/${id}`;
};

/**
 * @summary Delete supplier function
 */
export const deleteSupplierFunction = async (
  id: SupplierFunctionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteSupplierFunctionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRestoreSupplierFunctionUrl = (id: SupplierFunctionId) => {
  return `/api/v1/engineering/supplier-functions/${id}/restore`;
};

/**
 * @summary Restore supplier function
 */
export const restoreSupplierFunction = async (
  id: SupplierFunctionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreSupplierFunctionUrl(id), {
    ...options,
    method: "POST",
  });
};
